import script from "./CertificateModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CertificateModal.vue?vue&type=script&setup=true&lang=js"

import "./CertificateModal.vue?vue&type=style&index=0&id=4cd7a263&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cd7a263"]])

export default __exports__